import { CupsLoading, Slide1, Slide2, Slide3 } from '@/components/cups';
import { ROUTES } from '@/config';
import { Icon } from '@/core/icon';
import {
  Button,
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselScrollBar,
} from '@/core/ui';
import { API } from '@/store/api';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Cups = () => {
  const { i18n } = useTranslation();

  const {
    error,
    isLoading,
    isFetching,
    data: cup,
  } = API.cupApi.useGetCupInfoQuery({ locale: i18n.language }, { skip: !i18n.language });

  if (error) {
    return <p>Oh no, there was an error</p>;
  }

  if (isLoading || isFetching || !cup) {
    return <CupsLoading />;
  }

  const { national_cup_page, winners, pagination } = cup;

  return (
    <div className='w-full h-full'>
      <Carousel>
        <CarouselContent>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide1 cup={national_cup_page} />
          </CarouselItem>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide2 initialWinners={winners} initialPagination={pagination} />
          </CarouselItem>
          <CarouselItem className='pl-0 -mr-1'>
            <Slide3 gallery={national_cup_page.gallery} highlight={national_cup_page.highlight} />
          </CarouselItem>
        </CarouselContent>
        <CarouselNext className='bg-transparent! disabled:bg-transparent right-0 disabled:hidden'>
          <Icon name='CHEVRON_RIGHT' className='w-10 h-10' />
        </CarouselNext>
        <CarouselPrevious className='bg-transparent! disabled:bg-transparent left-0 disabled:hidden '>
          <Icon name='CHEVRON_LEFT' className='w-10 h-10' />
        </CarouselPrevious>
        <Link to={ROUTES.MAIN} className={'absolute z-10 top-14 right-20'}>
          <Button className='outline-hidden hover:bg-danger focus:bg-danger border-none flex px-7 py-8 bg-danger rounded-full items-center space-x-2'>
            <Icon className='h-5 w-5' name='CHEVRON_LEFT' />
            <Icon className='h-7 w-6' name='HOME' />
          </Button>
        </Link>
        <CarouselScrollBar />
      </Carousel>
    </div>
  );
};
export default Cups;
